import { useLocation, useParams } from 'react-router-dom';

export default function PublicRegistrationSuccess() {
  const { state } = useLocation();
  const { slug } = useParams();
  const protocol = state?.protocol;
  return (
    <main className="mx-auto max-w-2xl p-4 text-center">
      <h1 className="text-2xl font-bold text-green-700">Inscrição confirmada!</h1>
      {protocol && (
        <p className="mt-2">
          Seu protocolo: <strong>{protocol}</strong>
        </p>
      )}
      <p className="mt-2 text-gray-700">Você receberá um email de confirmação em breve.</p>
      <p className="mt-1 text-sm text-gray-500">Seletivo: {slug}</p>
    </main>
  );
}
